import Network from 'shared/libraries/network';
import CONFIG from 'shared/constants/config';
import {
  TRegisterRequest,
  TSmsSendRequest,
} from 'pages/login/store/loginSchema';

class AuthModel extends Network {
  constructor(baseURL: string, timeout = 120000) {
    super(baseURL, timeout);
  }

  //POST

  //Начальная авторизация в mini apps

  async postLogin<T>(data: {
    init_data: string;
    poll?: boolean;
    own_respondents_link_hash?: string;
  }): Promise<T> {
    return this.send('post', `/mini_app/login`, {
      init_data: !CONFIG.IS_DEV ? data.init_data : CONFIG.TG_ROW_DATA,
      // poll: data.poll || undefined,
      poll: true,
      own_respondents_link_hash: data?.own_respondents_link_hash,
    });
  }

  //Начальная авторизация в max
  async postLoginMax<T>(data: {
    init_data: string;
    poll?: boolean;
    own_respondents_link_hash?: string;
  }): Promise<T> {
    return this.send('post', `/max_mini_app/login`, {
      init_data: !CONFIG.IS_DEV ? data.init_data : CONFIG.MAX_ROW_DATA,
      // poll: data.poll || undefined,
      poll: true,
      own_respondents_link_hash: data?.own_respondents_link_hash,
    });
  }

  //Начальная авторизация в mini apps в web
  async postLoginWeb<T>(data: {
    phone: string;
    code: string;
    own_respondents_link_hash?: string;
  }): Promise<T> {
    return this.send('post', `/respondent/login`, {
      ...data,
    });
  }

  async postRegister<T>(data: TRegisterRequest): Promise<T> {
    return this.send('post', `/mini_app/register`, { ...data });
  }

  async postRegisterMax<T>(data: TRegisterRequest): Promise<T> {
    return this.send('post', `/max_mini_app/register`, { ...data });
  }

  async postRegisterWeb<T>(data: TRegisterRequest): Promise<T> {
    return this.send('post', `/respondent/register`, { ...data });
  }

  async postSmsSend<T>(data: TSmsSendRequest): Promise<T> {
    return this.send('post', `/sms`, {
      ...data,
    });
  }
}

const baseUrl: string = CONFIG.REACT_APP_API_BASE_URL as string;
const authModel = new AuthModel(baseUrl);
export default authModel;
